import ENUM from '../ENUM'
import ChartType from '../model/CharType'

export default function () {
    return {
        kind: 'QuestionSlide',
        filters: [
            {
                groupId: 'general',
                name: ENUM().chartType,
                options: ChartType.getOptions('KPI'),
            },
            {
                name: ENUM().comparisonSurveyIds,
            },
            {
                name: ENUM().benchmarks,
                options: [
                    {
                        label: ENUM().industry,
                        value: 'Industry',
                        name: ENUM().benchmarks,
                    },
                    {
                        label: ENUM().company,
                        value: 'Company',
                        name: ENUM().benchmarks,
                    },
                    {
                        label: ENUM().sector,
                        value: 'Sector',
                        name: ENUM().benchmarks,
                    },
                    {
                        label: ENUM().portfolio,
                        value: 'Portfolio',
                        name: ENUM().benchmarks,
                    },
                ],
            },
        ],
        references: [ENUM().pageQuestionId],
    }
}
